import Chart from "react-apexcharts";
import { Box } from "@mui/material";

export const ActivenessChart = ({activePercentage}) => {

    const categories = activePercentage.data.map(d => d.label);
    const usagePercentage = activePercentage.data.map(item =>item.usage);

    const options = {
        chart: {
            height: 350,
            type: 'area',
            zoom :{
                enabled: false
            }
        },
        colors:['#5DB55D'],
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        yaxis: {
            min: 0,
            max: 100,
            tickAmount: 5,
            labels: {
                formatter: (value) => `${value}%`
            }
        },
        xaxis: {
            categories: categories,
            labels: {
                rotate: 0,               
                rotateAlways: false,
            }
        },
        tooltip: {
            y: {
                formatter: (val) => `${val}%`
            },
            x: {
                format: 'MM/dd/yy'
            }
        }
    };

    const series = [
        {
            name: "Activeness",
            data: usagePercentage
        }
    ];

    return (
        <Box sx={{ width: "100%", height: "auto", minWidth: 300 }}>
            <Box id="bar-chart">
                <Chart options={options} series={series} type="area" height={456} />
            </Box>
        </Box>
    );
};
